import { pushEventInfo, setPageDetails, pushErrorEvent } from '../analytics';
var BUTTON_SUBMIT = 'button submission';
var MY_ACCT_SETTINGS = 'my account settings';
var BASE = 'account>purchase history';
var MAML = 'maml:orders';
var MY_ACCOUNT = 'my account';
var PAGE_LOAD_EVENT = 'order view';
export var setPurchaseHistoryPageAnalytics = function () {
    var purchaseHistoryPageData = {
        pageInfo: {
            pageName: BASE,
            pageType: MAML,
            pageLoadEvent: PAGE_LOAD_EVENT,
        },
        category: {
            primaryCategory: MY_ACCOUNT,
            subCategory1: BASE,
            subCategory2: BASE,
        },
    };
    setPageDetails(purchaseHistoryPageData);
};
/**
 * Event analtyics for purchase history
 */
export var pushPurchaseHistorySearchEvent = function (searchCriteria, searchByTerm) {
    pushEventInfo({
        category: { primaryCategory: BUTTON_SUBMIT },
        eventInfo: { eventName: MY_ACCT_SETTINGS },
        myAccount: {
            settings: "purchase history: search button",
            searchTerm: searchCriteria,
            searchBy: searchByTerm,
        },
    });
};
export var pushPurchaseHistorySortEvent = function (sortName, searchBy) {
    var correctedSortName = {
        salesDate: 'date',
        orderNumber: 'order number',
        POJobName: 'po job name',
        invoiceNumber: 'invoice number',
        buyerName: 'buyer name',
        buyerId: 'buyer id',
        registerNumber: 'register number',
        storeNumber: 'store number',
        totalAmount: 'total amount',
        accountIdType: 'account id type',
        yesterday: 'yesterday',
        last7Days: 'last 7 days',
        last30Days: 'last 30 days',
        thisMonth: 'this month',
        lastMonth: 'last month',
        last6Months: 'last 6 months',
        last12Months: 'last 12 months',
        last25Months: 'last 25 months',
        last2Years: 'last 2 years',
        YTD: 'year to date',
        custom: 'custom',
        storeName: 'store name',
        SKUNumber: 'sku number',
        departmentNumber: 'department number',
        itemDescription: 'item description',
        creditDebitCard: 'credit debit card',
        proXtrareloadableCard: 'pro xtra reloadable card',
        giftCard: 'gift card',
        checkingAccount: 'checking account',
        THDKeyTag: 'thd key tag',
        phoneNumber: 'phone number',
    }[sortName];
    var searchOrSort = searchBy ? 'search by' : 'sort by';
    pushEventInfo({
        category: { primaryCategory: BUTTON_SUBMIT },
        eventInfo: { eventName: MY_ACCT_SETTINGS },
        myAccount: {
            settings: "purchase history: ".concat(searchOrSort, " ").concat(correctedSortName),
        },
    });
};
export var pushPurchaseHistoryAddCardEvent = function () {
    pushEventInfo({
        category: { primaryCategory: 'stash' },
        eventInfo: { eventName: MY_ACCT_SETTINGS },
        eventMode: 'stash',
        myAccount: {
            settings: 'purchase history: no purchases found: add card link',
        },
    });
};
export var pushPurchaseHistoryHeaderButtonEvent = function (action) {
    return pushEventInfo({
        category: { primaryCategory: BUTTON_SUBMIT },
        eventInfo: { eventName: MY_ACCT_SETTINGS },
        myAccount: { settings: "purchase history: ".concat(action) },
    });
};
export var pushQuickBookExportEvent = function (setting) {
    pushEventInfo({
        category: { primaryCategory: BUTTON_SUBMIT },
        eventInfo: { eventName: MY_ACCT_SETTINGS },
        myAccount: { settings: setting },
    });
};
export var pushOrderDetailsOrderCardEvent = function () {
    pushEventInfo({
        category: { primaryCategory: 'stash' },
        eventInfo: { eventName: MY_ACCT_SETTINGS },
        eventMode: 'stash',
        myAccount: { settings: 'purchase history: order card: card click' },
    });
};
// TODO: feature is not currently in experience, suppose logic was changed.
// const pushEReciptNavButtonEvent = (action: 'previous' | 'next') =>
//   pushEventInfo({
//     category: { primaryCategory: BUTTON_SUBMIT },
//     eventInfo: { eventName: MY_ACCT_SETTINGS },
//     myAccount: { settings: `ereceipt overlay: ${action} button` },
//   });
export var pushEReceiptOverlayEvent = function () {
    return pushEventInfo({
        category: { primaryCategory: 'overlay' },
        eventInfo: { eventName: 'customer receipt' },
    });
};
/**
 * Error analtyics for purhcase history
 */
/* pushErrorEvent(
  pageSection: section,
  code: error.response ? error.response.status : error.status,
  message: error.response ? error.response.statusText : error.statusText,
  displayType: type,
); */
export var setPurchaseHistoryPageError = function (error) {
    var _a;
    return pushErrorEvent('purchase history', ((_a = error.status) === null || _a === void 0 ? void 0 : _a.toString()) || '', error.message, 'page');
};
export var setNoRecordsFoundError = function () {
    return pushErrorEvent('purchase history', '200', 'No Records Found', 'page');
};
export var setMoreThan390RecordsError = function () {
    return pushErrorEvent('purchase history', '200', 'More Than 390 Records', 'page');
};
export var setHOrderError = function (errorMessage) {
    return pushErrorEvent('purchase history add online receipt', '400', errorMessage, 'inline');
};
export var setAddReceiptError = function (status, message) {
    return pushErrorEvent('purchase history add receipt', status || '', message, 'inline');
};
export var setExportHistoryError = function (error) {
    var _a, _b, _c, _d, _e, _f;
    return pushErrorEvent('purchase history export account history', ((_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.errors) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.code) || '', ((_f = (_e = (_d = error === null || error === void 0 ? void 0 : error.errors) === null || _d === void 0 ? void 0 : _d.error) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.statusText) || '', 'inline');
};
export var setPrintHistoryError = function (error) {
    var _a, _b, _c, _d, _e, _f;
    return pushErrorEvent('purchase history print', ((_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.errors) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.code) || '', ((_f = (_e = (_d = error === null || error === void 0 ? void 0 : error.errors) === null || _d === void 0 ? void 0 : _d.error) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.statusText) || '', 'inline');
};
export var setEditJobNameError = function (error) {
    var _a, _b, _c, _d, _e, _f;
    return pushErrorEvent('purchase history edit po/jobname', ((_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.errors) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.code) || '', ((_f = (_e = (_d = error === null || error === void 0 ? void 0 : error.errors) === null || _d === void 0 ? void 0 : _d.error) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.statusText) || '', 'inline');
};
export var setViewReceiptError = function (error) {
    var _a, _b, _c, _d, _e, _f;
    return pushErrorEvent('purchase history customer receipt', ((_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.errors) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.code) || '', ((_f = (_e = (_d = error === null || error === void 0 ? void 0 : error.errors) === null || _d === void 0 ? void 0 : _d.error) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.statusText) || '', 'inline');
};
export var setQBSyncError = function (error) {
    var _a, _b, _c, _d, _e, _f;
    return pushErrorEvent('purchase history quickbooks sync', ((_c = (_b = (_a = error === null || error === void 0 ? void 0 : error.errors) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.code) || '', ((_f = (_e = (_d = error === null || error === void 0 ? void 0 : error.errors) === null || _d === void 0 ? void 0 : _d.error) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.statusText) || '', 'inline');
};
/** `Purchase History - Track Delivery Button Clicked` */
export var pushDeliveryTrackerButtonClickedEvent = function () {
    return pushEventInfo({
        category: { primaryCategory: 'button submission' },
        eventInfo: { eventName: MY_ACCT_SETTINGS },
        myAccount: {
            settings: 'purchase history: track delivery',
        },
    });
};
